[
  {
    "classement": "1",
    "nom": "Martin Damphousse",
    "titre": "Maire",
    "remuneration": "100368",
    "allocation": "17546",
    "remuneration2": "94132",
    "allocation2": "0",
    "total": "212046",
    "ville": "Varennes",
    "code": "59020",
    "region_adm": "Montérégie (16)",
    "Population": "21584",
    "fonction_base": "Maire de Varennes",
    "fonction_additionnelle": "Membre du comité exécutif de la Communauté métropolitaine de Montréal (CMM); Membre du conseil d'administration de l'Autorité régionale de transport métropolitain (ARTM); Membre du conseil de la MRC Marguerite D'Youville"
  },
  {
    "classement": "2",
    "nom": "Valérie Plante",
    "titre": "Mairesse",
    "remuneration": "121193",
    "allocation": "17492",
    "remuneration2": "73179",
    "allocation2": "0",
    "total": "211864",
    "ville": "Montréal",
    "code": "66023",
    "region_adm": "Montréal (06)",
    "Population": "1800055",
    "fonction_base": "Mairesse de Montréal",
    "fonction_additionnelle": "Présidente du comité exécutif de la Communauté métropolitaine de Montréal (CMM); Membre du conseil d'administration de l'Autorité régionale de transport métropolitain (ARTM)"
  },
  {
    "classement": "3",
    "nom": "Jonathan Tabarah",
    "titre": "Conseiller",
    "remuneration": "171580",
    "allocation": "17546",
    "remuneration2": "13187",
    "allocation2": "0",
    "total": "202313",
    "ville": "Longueuil",
    "code": "58227",
    "region_adm": "Montérégie (16)",
    "Population": "253629",
    "fonction_base": "Conseiller de Longueuil; Vice-président du comité executif; Maire suppléant",
    "fonction_additionnelle": "Membre du conseil d'administration de la Communauté métropolitaine de Montréal (CMM)"
  },
  {
    "classement": "4",
    "nom": "Mathieu Traversy",
    "titre": "Maire",
    "remuneration": "120788",
    "allocation": "17546",
    "remuneration2": "58612",
    "allocation2": "0",
    "total": "196946",
    "ville": "Terrebonne",
    "code": "64008",
    "region_adm": "Lanaudière (14)",
    "Population": "122098",
    "fonction_base": "Maire de Terrebonne",
    "fonction_additionnelle": "Membre du conseil d'administration d'Exo; Préfet MRC des Moulins; Membre du conseil d'administration de la Communauté métropolitaine de Montréal (CMM)"
  },
  {
    "classement": "5",
    "nom": "Stéphane Boyer",
    "titre": "Maire",
    "remuneration": "114629",
    "allocation": "17546",
    "remuneration2": "64751",
    "allocation2": "0",
    "total": "196926",
    "ville": "Laval",
    "code": "65005",
    "region_adm": "Laval (13)",
    "Population": "446369",
    "fonction_base": "Maire de Laval",
    "fonction_additionnelle": "Vice-président du comité exécutif de la Communauté métropolitaine de Montréal (CMM); Membre du conseil d’administration de l’Autorité régionale de transport métropolitain (ARTM)"
  },
  {
    "classement": "6",
    "nom": "Bruno Marchand",
    "titre": "Maire",
    "remuneration": "176208",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "193754",
    "ville": "Québec",
    "code": "23027",
    "region_adm": "Capitale-Nationale (03)",
    "Population": "556066",
    "fonction_base": "Maire de Québec",
    "fonction_additionnelle": "Président de la Communauté métropolitaine de Québec"
  },
  {
    "classement": "7",
    "nom": "Luc Rabouin",
    "titre": "Maire d'arrondissement",
    "remuneration": "139115",
    "allocation": "17492",
    "remuneration2": "35000",
    "allocation2": "0",
    "total": "191607",
    "ville": "Montréal",
    "code": "66023",
    "region_adm": "Montréal (06)",
    "Population": "1800055",
    "fonction_base": "Maire d'arrondissement Le Plateau-Mont-Royal; Membre comité exécutif de Montréal",
    "fonction_additionnelle": "Membre du comité exécutif de la Communauté métropolitaine de Montréal (CMM)"
  },
  {
    "classement": "8",
    "nom": "Benoît Dorais",
    "titre": "Maire d'arrondissement",
    "remuneration": "166521",
    "allocation": "17492",
    "remuneration2": "7500",
    "allocation2": "0",
    "total": "191513",
    "ville": "Montréal",
    "code": "66023",
    "region_adm": "Montréal (06)",
    "Population": "1800055",
    "fonction_base": "Maire d'arrondissement Le Sud-Ouest; Vice-président du comité exécutif de Montréal",
    "fonction_additionnelle": "Membre de la Commission de l’habitation et de la cohésion sociale de la Communauté métropolitaine de Montréal (CMM)"
  },
  {
    "classement": "9",
    "nom": "Michel Angers",
    "titre": "Maire",
    "remuneration": "115540",
    "allocation": "17546",
    "remuneration2": "55765",
    "allocation2": "0",
    "total": "188851",
    "ville": "Shawinigan",
    "code": "36033",
    "region_adm": "Mauricie (04)",
    "Population": "51508",
    "fonction_base": "Maire de Shawinigan",
    "fonction_additionnelle": "Membre de la Table des élus de la Mauricie; Membre du conseil permanent sur les services policiers du Québec; Président de la Régie de gestion des matières résiduelles de la Mauricie"
  },
  {
    "classement": "10",
    "nom": "Catherine Fournier",
    "titre": "Mairesse",
    "remuneration": "106462",
    "allocation": "17546",
    "remuneration2": "64751",
    "allocation2": "0",
    "total": "188759",
    "ville": "Longueuil",
    "code": "58227",
    "region_adm": "Montérégie (16)",
    "Population": "253629",
    "fonction_base": "Mairesse de Longueuil; Présidente du comité exécutif de Longueuil",
    "fonction_additionnelle": "Vice-présidente du comité exécutif de la Communauté métropolitaine de Montréal (CMM); Membre du conseil d’administration de l’Autorité régionale de transport métropolitain (ARTM)"
  },
  {
    "classement": "11",
    "nom": "Dominique Ollivier",
    "titre": "Conseillère",
    "remuneration": "135330",
    "allocation": "17492",
    "remuneration2": "35000",
    "allocation2": "0",
    "total": "187822",
    "ville": "Montréal",
    "code": "66023",
    "region_adm": "Montréal (06)",
    "Population": "1800055",
    "fonction_base": "Présidente du comité exécutif de Montréal",
    "fonction_additionnelle": "Membre du comité exécutif de la Communauté métropolitaine de Montréal (CMM)"
  },
  {
    "classement": "12",
    "nom": "Évelyne Beaudin",
    "titre": "Mairesse",
    "remuneration": "169202",
    "allocation": "17546",
    "remuneration2": "596",
    "allocation2": "0",
    "total": "187344",
    "ville": "Sherbrooke",
    "code": "43027",
    "region_adm": "Estrie (05)",
    "Population": "175114",
    "fonction_base": "Mairesse de Sherbrooke; Présidente du comité exécutif de Sherbrooke",
    "fonction_additionnelle": "Représentante à la Table des MRC de l'Estrie"
  },
  {
    "classement": "13",
    "nom": "Miguel Lemieux",
    "titre": "Maire",
    "remuneration": "111039",
    "allocation": "17546",
    "remuneration2": "58700",
    "allocation2": "0",
    "total": "187285",
    "ville": "Salaberry-de-Valleyfield",
    "code": "70052",
    "region_adm": "Montérégie (16)",
    "Population": "44838",
    "fonction_base": "Maire Salaberry-de-Valleyfield",
    "fonction_additionnelle": "Préfet de la MRC Beauharnois-Salaberry"
  },
  {
    "classement": "14",
    "nom": "Stéphanie Lacoste",
    "titre": "Mairesse",
    "remuneration": "126262",
    "allocation": "17546",
    "remuneration2": "40746",
    "allocation2": "0",
    "total": "184554",
    "ville": "Drummondville",
    "code": "49058",
    "region_adm": "Centre-du-Québec (17)",
    "Population": "81551",
    "fonction_base": "Mairesse de Drummondville; Présidente du comité exécutif de Drummondville",
    "fonction_additionnelle": "Préfète de la MRC de Drummond; Membre du Comité d'aménagement (CAM) de la MRC de Drummond; Membre du Comité consultatif agricole (CCA) de la MRC de Drummond"
  },
  {
    "classement": "15",
    "nom": "Gilles Lehouillier",
    "titre": "Maire",
    "remuneration": "165285",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "182831",
    "ville": "Lévis",
    "code": "25213",
    "region_adm": "Chaudière-Appalaches (12)",
    "Population": "154091",
    "fonction_base": "Maire de Lévis",
    "fonction_additionnelle": "Vice-président de la Communauté métropolitaine de Québec"
  },
  {
    "classement": "16",
    "nom": "Doreen Assad",
    "titre": "Mairesse",
    "remuneration": "103144",
    "allocation": "17456",
    "remuneration2": "61195",
    "allocation2": "0",
    "total": "181795",
    "ville": "Brossard",
    "code": "58007",
    "region_adm": "Montérégie (16)",
    "Population": "91693",
    "fonction_base": "Mairesse Brossard",
    "fonction_additionnelle": "Présidente de la Commission de développement économique, des finances et de l’emploi de la Communauté métropolitaine de Montréal (CMM); Vice-présidente du Réseau de transport de Longueuil (RTL); Membre du conseil d’administration de Tourisme Montérégie"
  },
  {
    "classement": "17",
    "nom": "Guillaume Tremblay",
    "titre": "Maire",
    "remuneration": "94282",
    "allocation": "17546",
    "remuneration2": "69451",
    "allocation2": "0",
    "total": "181279",
    "ville": "Mascouche",
    "code": "64015",
    "region_adm": "Lanaudière (14)",
    "Population": "53009",
    "fonction_base": "Maire de Mascouche",
    "fonction_additionnelle": "Préfet de la MRC Les Moulins; Membre du conseil d’administration de la Communauté métropolitaine de Montréal (CMM); Président de la Commission de l’habitation et de la cohésion sociale de la CMM"
  },
  {
    "classement": "18",
    "nom": "France Bélisle",
    "titre": "Mairesse",
    "remuneration": "163595",
    "allocation": "17546",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "181141",
    "ville": "Gatineau",
    "code": "81017",
    "region_adm": "Outaouais (07)",
    "Population": "292281",
    "fonction_base": "Mairesse de Gatineau",
    "fonction_additionnelle": "Aucune fonction additionnelle"
  },
  {
    "classement": "19",
    "nom": "Caroline Bourgeois",
    "titre": "Mairesse d'arrondissement",
    "remuneration": "163621",
    "allocation": "17492",
    "remuneration2": "0",
    "allocation2": "0",
    "total": "181113",
    "ville": "Montréal",
    "code": "66023",
    "region_adm": "Montréal (06)",
    "Population": "1800055",
    "fonction_base": "Mairesse d'arrondissement de Rivière-des-Prairies–Pointe-aux-Trembles; Vice-présidente du comité-exécutif",
    "fonction_additionnelle": "Aucune fonction additionnelle"
  },
  {
    "classement": "20",
    "nom": "Patrick Bousez",
    "titre": "Maire",
    "remuneration": "18147",
    "allocation": "9073",
    "remuneration2": "143873",
    "allocation2": "8175",
    "total": "179268",
    "ville": "Rivière-Beaudette",
    "code": "71005",
    "region_adm": "Montérégie (16)",
    "Population": "2580",
    "fonction_base": "Maire Rivière-Beaudette",
    "fonction_additionnelle": "Préfet de la MRC de Vaudreuil-Soulanges; Vice-président représentant les MRC faisant partie de la Communauté métropolitaine de Montréal (CMM); Président du Regroupement des tables décisionnelles de la Montérégie"
  },
  {
    "classement": "21",
    "nom": "Pierre Charron",
    "titre": "Maire",
    "remuneration": "106076",
    "allocation": "17592",
    "remuneration2": "53 575",
    "allocation2": "0",
    "total": "177243",
    "ville": "Saint-Eustache",
    "code": "72005",
    "region_adm": "Laurentides (15)",
    "Population": "46434",
    "fonction_base": "Maire Saint-Eustache",
    "fonction_additionnelle": "Préfet de la MRC de Deux-Montagnes; Membre du conseil d'administration d'EXO ; Membre du Comité de développement économique de la MRC de Deux-Montagnes"
  }
]